import { useEffect, useState, type RefObject } from 'react';

/**
 * 표의 '가변 열' 폭 — 남는 폭을 한 열이 다 먹지 않게 상한을 둔다 (2026-11-05, 온습도로거 표 실측).
 *
 * 열은 내용 폭으로 고정하고 가변 열 하나가 남는 폭을 받던 방식(2026-11-05 오전)은 1920 에서
 * '지점 · 설치 위치' 가 내용 279px 에 1048px 를 차지해 다음 열이 화면 가운데로 밀려났다(특정 열 편중).
 * 그래서 가변 열은 [min, max] 안에서만 늘고, 그래도 남는 폭은 작업 열 앞의 **빈 간격 열(FLEX_SPACER)** 이 받는다
 * — 읽는 열들은 붙어 있고 여백은 한곳(작업 버튼 앞)에 모인다. 좁은 화면에서는 min 까지 줄어 가로 스크롤을 만들지 않는다.
 *
 * @param fixedSum 가변 열 · 간격 열을 뺀 나머지 열 폭의 합(선택 · 펼침 열 포함)
 */
export function useFlexColumn(wrapRef: RefObject<HTMLElement | null>, fixedSum: number, min: number, max: number) {
  const [w, setW] = useState(min);
  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const calc = () => {
      const W = el.clientWidth;
      if (W) setW(Math.max(min, Math.min(max, W - fixedSum - 2)));   // 2 = 테두리 여유
    };
    calc();
    const ro = new ResizeObserver(calc);
    ro.observe(el);
    return () => ro.disconnect();
  }, [wrapRef, fixedSum, min, max]);
  return w;
}

/** 남는 폭을 받는 빈 열 — 머리 · 본문 모두 비어 있다(가변 열의 상한을 넘는 폭만 여기로 온다) */
export const FLEX_SPACER = { key: '__spacer', title: '', render: () => null, onHeaderCell: () => ({ 'aria-hidden': true }), onCell: () => ({ 'aria-hidden': true }) };
